/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import * as url from 'url';
export default class LibrariesUtil {
	/**
	 * Get external link url which has x-product name and location.
	 * @param url
	 * @param guid
	 * @returns {string}
	 */
	static getExternalLink(url: string, guid?: string) {
		const connector = url.indexOf('?') > -1 ? '&' : '?';
		const extUrl = `${url}${connector}x-product=CCHome&x-product-location=Libraries`;
		if (!guid) {
			return extUrl;
		}
		return `${extUrl}&guid=${guid}`;
	}

	static extractQueryParamValue(inputUrl, queryParamField) {
		if (inputUrl) {
			const urlParams: any = url.parse(inputUrl, true).query;
			return urlParams[queryParamField];
		}
	}
}
